module.exports = __webpack_public_path__ + "media/images/market-08e8688812435c0d82870ca10b146e79.svg";